export default "__VITE_ASSET__FXcXzlxa__"